import { createSlice } from "@reduxjs/toolkit";
import {
  GetSingleWebinarData,
  GetWebinarData,
  WebinarInitialStatus,
} from "../../../../types/eventManage/webinars";
import {
  createWebinarAsync,
  getAllWebinarAsync,
  singWebinarDataAsync,
  updateWebinarAsync,
} from "./webinarsApi";

const initialState: WebinarInitialStatus<GetWebinarData, GetSingleWebinarData> =
  {
    loading: false,
    manageLoading: false,
    webinarList: [],
    singleWebinarData: null,
    countWebinar: 0,
  };

const manageWebinarSlice = createSlice({
  name: "admin-webinar",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // create
    builder
      .addCase(createWebinarAsync.pending, (state) => {
        state.manageLoading = true;
      })
      .addCase(createWebinarAsync.fulfilled, (state) => {
        state.manageLoading = false;
      })
      .addCase(createWebinarAsync.rejected, (state) => {
        state.manageLoading = false;
      });

    // get all
    builder
      .addCase(getAllWebinarAsync.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getAllWebinarAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.webinarList = action.payload.data;
        state.countWebinar = action.payload.length;
      })
      .addCase(getAllWebinarAsync.rejected, (state) => {
        state.loading = false;
        state.webinarList = [];
        state.countWebinar = 0;
      });

    // update
    builder
      .addCase(updateWebinarAsync.pending, (state) => {
        state.manageLoading = true;
      })
      .addCase(updateWebinarAsync.fulfilled, (state) => {
        state.manageLoading = false;
      })
      .addCase(updateWebinarAsync.rejected, (state) => {
        state.manageLoading = false;
      });

    // single
    builder
      .addCase(singWebinarDataAsync.pending, (state) => {
        state.manageLoading = true;
        state.singleWebinarData = null;
      })
      .addCase(singWebinarDataAsync.fulfilled, (state, action) => {
        state.manageLoading = false;
        state.singleWebinarData = action.payload;
      })
      .addCase(singWebinarDataAsync.rejected, (state) => {
        state.manageLoading = false;
        state.singleWebinarData = null;
      });
  },
});

export default manageWebinarSlice;
